import { Component, Input, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-multiple-fields",
  templateUrl: "./multiple-fields.component.html",
  styleUrls: ["./multiple-fields.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultipleFieldsComponent),
      multi: true,
    },
  ],
})
export class MultipleFieldsComponent implements ControlValueAccessor {
  @Input() label!: string;

  @Input() editMode = false;

  @Input() options?: { value: any; label: string; translate: boolean }[] = [{ value: 0, label: "", translate: false }];

  @Input() type? = "text";
  @Input() isInput = false;

  @Input() required = false;
  @Input() requiredError = false;

  value: any = null;

  /**
   * Propagates a new value to the form model, replaced by the form's callback in registerOnChange().
   * @param value The new value
   */
  onChange: (value: any) => void = () => {
    return;
  };
  /**
   * Marks the field as touched in the form model, replaced by the form's callback in registerOnTouched().
   */
  onTouched: () => void = () => {
    return;
  };

  /**
   * Writes a new value from the form model into the component.
   * @param value New value to display
   */
  writeValue(value: any): void {
    this.value = value;
  }

  /**
   * Registers the callback to invoke when the value changes.
   * @param fn Callback to invoke with the new value
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * Registers the callback to invoke when the field is touched.
   * @param fn Callback to invoke on touch
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  /**
   * Handles input changes, converting the raw value to a number when needed and propagating it.
   * @param event Input event triggered by the field
   */
  onInput(event: Event): void {
    const raw = (event.target as HTMLInputElement).value;

    const newValue = raw === "" ? null : this.type === "number" ? Number(raw) : raw;

    this.value = newValue;
    this.onChange(newValue);
  }

  /**
   * Handles selection changes on the dropdown and propagates the selected option's value.
   * @param event Change event triggered by the select
   */
  onSelect(event: Event): void {
    const select = event.target as HTMLSelectElement;

    const newValue = this.options?.[select.selectedIndex]?.value;

    this.value = newValue;
    this.onChange(newValue);
  }
}
